import React from 'react';
import { createState, useState } from '@hookstate/core';
import { authFetch } from '~/services/fetch';
import type { ListDevicesProps } from '../interfaces/IListDevicesprops';
import type IDisconnectMultipleDevices from '../interfaces/IListDevicesprops';

const defaultListDevicesProps: ListDevicesProps = {
  canConnectDevice: false,
  canDisconnectDevice: false,
  canTransferDevice: false,
  canSeeCrew: false,
  canEditCrew: false,
  canSetOutOfService: false,
  canSetReturnToService: false,
  canSetOnMission: false,
  canSetBackToAvailable: false,
  openDisconnectDialog: false,
  openCrewDialog: false,
  openConectDispatchDevice: false,
  openOutOfServiceDialog: false,
  openTransferDevice: false,
  openChronologyDevice: false,
  openReturnToServiceDialog: false,
  isOpenDialog: false,
  lockTemporaryTracking: false,
  openModalResultMultipleDisconnectDevice: false,
  enableButtonResultMultipleTransfertDevice: false,
  openBackToAvailable: false,
  openOnMission: false,
  
  plate: null,
  identification: '',
  deviceId: null,
  agencyId: null,
  labelCommander: null,
  labelDriver: null,
  labelPatrolmans: null,
  labelKmInitial: null,
  dispatchGroup: null,
  trackingId: '',

}

const listDevicesDefaultState = createState<ListDevicesProps>(Object.create(defaultListDevicesProps))
const listDevicesDisconnectMultipleSocketStore = [];
const listDevicesTransferMultipleSocketStore = [];
const enableButtonShowResumeTransferMultipleStore = false

const store = createState<IDisconnectMultipleDevices>({
  listDevicesDisconnectMultipleSocket: listDevicesDisconnectMultipleSocketStore,
  listDevicesTransferMultipleSocket: listDevicesTransferMultipleSocketStore,
  enableButtonShowResumeTransferMultipleSocket: enableButtonShowResumeTransferMultipleStore
});

export default function useListDevicesSocket() {
  const listDevicesState = useState(listDevicesDefaultState);
  const listDevicesMultipleDisconnect = useState(store.listDevicesDisconnectMultipleSocket);
  const listDevicesMultipleTransfer = useState(store.listDevicesTransferMultipleSocket);
  const enableButtonShowResumeTransferMultiple = useState(store.enableButtonShowResumeTransferMultipleSocket)

  return ({
    listDevicesState: () => listDevicesState,
    listDevicesMultipleDisconnect: () => listDevicesMultipleDisconnect,
    listDevicesMultipleTransfer: () => listDevicesMultipleTransfer,
    openModalResultMultipleDisconnectDevice: () => listDevicesDefaultState.openModalResultMultipleDisconnectDevice,
    enableButtonShowResumeTransferMultiple: enableButtonShowResumeTransferMultiple,
    handleMenuActions: (row) => {
      listDevicesState.identification.set(row.identification);
      listDevicesState.lockTemporaryTracking.set(row.lockTemporaryTracking);
      listDevicesState.deviceId.set(row.id);
      listDevicesState.agencyId.set(row.agencyId);
      listDevicesState.canEditCrew.set(row.statusId === 1);
      listDevicesState.canSeeCrew.set(row.statusId !== 10);
      listDevicesState.canConnectDevice.set((row.statusId == 10));
      listDevicesState.canTransferDevice.set((row.statusId == 10 || row.statusId == 1));
      listDevicesState.canDisconnectDevice.set((row.statusId == 1));
      listDevicesState.canSetOutOfService.set((row.statusId == 1));
      listDevicesState.canSetReturnToService.set((row.statusId == 11));
      listDevicesState.canSetOnMission.set((row.statusId == 1));
      listDevicesState.canSetBackToAvailable.set((row.statusId == 12));
      listDevicesState.plate.set(row.plate);
      listDevicesState.labelCommander.set(row?.deviceType?.label_commander ?? 'Comandante');
      listDevicesState.labelDriver.set(row?.deviceType?.label_driver ?? 'Motorista');
      listDevicesState.labelPatrolmans.set(row?.deviceType?.label_patrolmans ?? 'Patrulheiro');
      listDevicesState.labelKmInitial.set(row?.deviceType?.label_km_initial);
      listDevicesState.dispatchGroup.set(row?.dispatchGroupId);
      listDevicesState.trackingId.set(row.trackingId);
    },
    returnToServiceDevice: async () => {
      const deviceReturnToServiceId = listDevicesState.deviceId.get();
      if (!deviceReturnToServiceId) {
        return
      };

      try {
        const response = await authFetch({
          url: '/device/back-to-service',
          method: 'POST',
          data: {
            'device_id': deviceReturnToServiceId,
          }
        })
        return response;
      } catch (error) {
        console.error(error);
      } finally {
        listDevicesState.openReturnToServiceDialog.set(false);
      }
    },
    disconnectDevice: async () => {
      const deviceClosureId = listDevicesState.deviceId.get();
      if (!deviceClosureId) {
        return
      };

      try {
        const response = await authFetch({
          url: '/auth/logout/device/external',
          method: 'POST',
          data: {
            'device_id': deviceClosureId,
          }
        })
        return response;

      } catch (error) {
        console.error(error);
      } finally {
        listDevicesState.openDisconnectDialog.set(false);
      }
    },
    getListDevicesDisconnects: (param) => {
      listDevicesMultipleDisconnect.merge([{
        device: param.device,
        dispatch_group_id: param.dispatch_group_id,
        error: param.error,
        imei: param.imei
      }])
    },
    setBackToAvailable: async () => {
      const deviceBackToAvailable = listDevicesState.deviceId.get();
      if (!deviceBackToAvailable) {
        return
      }

      try {
        const response = await authFetch({
          url: '/device/back-to-available',
          method: 'POST',
          data: {
            device_id: deviceBackToAvailable
          }
        })

        return response

      } catch (error) {
        console.log(error)
      } finally {
        listDevicesState.openBackToAvailable.set(false)
      }
    },
    getListDevicesMultiplesTransfer: async (param) => {
      try {
        listDevicesMultipleTransfer.merge([{
          device: param.device,
          dispatch_group_id: param.dispatch_group_id,
          error: param.error,
        }])
      } catch (error) {
        console.error(error);
      }

    },
  })
}